import React from 'react'

export default function Alert({text, isAlert}) {
  return (
    <div className={`fixed transition-all duration-300 ${window.innerWidth > 800 ? "top-[110px] right-[95px]" : "bottom-[135px] right-[5px]"}  w-[200px] rounded-[200px] px-5 py-2 bg-black ${isAlert ? "scale-100" : "scale-0"}`}>
        {text}
    </div>
  )
}
